import { InterviewSession } from '@helpers/session';

export function useInterviewSession() {
  return new InterviewSession();
}
